import SEO from '@/components/base/SEO';
import SchemaOrg from '@/components/base/SchemaOrg';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import FeaturedSection from './components/FeaturedSection';
import LatestSection from './components/LatestSection';
import CategorySection from './components/CategorySection';
import FAQSection from './components/FAQSection';

export default function Home() {
  return (
    <>
      <SEO />
      <SchemaOrg type="Organization" />
      <SchemaOrg type="WebSite" />
      <SchemaOrg type="WebPage" data={{
        name: '可游漫画网 - 韩国漫画在线免费阅读',
        description: '可游漫画网提供无删减韩国漫画下拉式阅读，韩漫在线免费阅读资源齐全且持续更新，从新作到经典应有尽有，满足多样化阅读喜好。',
        url: 'https://szwlst.cn/',
      }} />

      <Navbar />

      <main>
        <HeroSection />
        <FeaturedSection />
        <LatestSection />
        <CategorySection />
        <FAQSection />
      </main>

      <Footer />
    </>
  );
}